import { EComponent } from '../models/base';
import { EPostType, EScope, IPostModel } from '../models/post.model';
import { IPaginationData, IPaginationQuery, request } from './base';

function getList(
  query: IPaginationQuery & {
    type?: EPostType;
    scope?: EScope;
    component?: EComponent;
    order?: 'ASC' | 'DESC';
    sort_by?: string;
    keyword?: string;
  },
) {
  return request<IPaginationData<IPostModel>>({
    url: '/post',
    method: 'GET',
    params: query,
  });
}

function getDetail(id: string) {
  return request<IPostModel>({
    url: `/post/${id}`,
    method: 'GET',
  });
}

function create(data: Partial<IPostModel>) {
  return request<IPostModel>({
    url: `/post`,
    method: 'POST',
    data,
  });
}

function update(id: string, data: Partial<IPostModel>) {
  return request<IPostModel>({
    url: `/post/${id}`,
    method: 'PATCH',
    data,
  });
}

function remove(id: string) {
  return request<IPostModel>({
    url: `/post/${id}`,
    method: 'DELETE',
  });
}

const postApi = Object.freeze({
  getList,
  getDetail,
  update,
  create,
  remove,
});

export default postApi;
